
import { getVideoFromPlaylist } from '@/utils';

import { sendRoomData, getGroupID } from './actions-webrtc'
import { getItemByValue } from '../utils'

// Called WebRTC receives a message from peer
// Not a great idea but simply dispatches message along
export const receiveMessage = ({ dispatch }, { message, peer_id }) => {
	dispatch(message.type, { message, peer_id });
}

export const sendMessage = ({ state, commit }, { message, peer_id }) => {
	if(peer_id) {
		// send to one person
		// make sure data channel is open before sending
		if(state.peers[peer_id].data.readyState == "open") {
			state.peers[peer_id].data.send(JSON.stringify(message));
		}
	} else {
		// send to everybody
		for(let peer_id in state.peers) {
			if(state.peers[peer_id].connection.connectionState == 'failed' || state.peers[peer_id].connection.iceConnectionState == 'disconnected') { // if connection is closed, remove peer
				commit('removePeer', peer_id)
			} else if(state.peers[peer_id].data.readyState == "open") { // make sure data connection is open
				state.peers[peer_id].data.send(JSON.stringify(message))
			}
		}
	}

	if(getGroupID().toLowerCase() == 'coffeeshop' || getGroupID().toLowerCase() == 'desn 350 public space' || getGroupID().toLowerCase() == 'cozy coffeeshop' ||  getGroupID().toLowerCase() == 'lesswrong community weekend'){
		if(message.type.toLowerCase().match(/(room|object)/) && (!message.type.toLowerCase().match(/props/) || (message.props != undefined && (getItemByValue(message.props, 'prop', 'dragging')||{}).value === false))) {
			console.log('SENDING DATA')
			sendRoomData({
				objects: state.objects,
				rooms: state.rooms
			})
		}
	}
}


export const initPeer = ({ state, dispatch, getters }, peer_id) => {
	dispatch('sendMessage', { message: { type: 'receiveName', name: state.self.name }, peer_id });
	dispatch('sendMessage', { message: { type: 'receiveColor', color: state.self.color }, peer_id });
	dispatch('sendMessage', { message: { type: 'receivePosition', x: state.self.x, y: state.self.y }, peer_id });
	dispatch('sendMessage', { message: { type: 'receiveDirection', angle: state.self.angle }, peer_id });
	dispatch('sendMessage', { message: { type: 'receiveFaceDistance', distance: state.self.faceDistance }, peer_id })

	dispatch('sendMessage', { message: { type: 'receiveMuted', muted: state.self.muted }, peer_id });

	dispatch('sendMessage', { message: { type: 'receiveOrder', order: state.self.order }, peer_id });

	//console.log('VIP', getters.getVIP, getters.getVIP == state.self);
}


export const updateName = ({ commit, dispatch }, name) => {
	dispatch('sendMessage', { message: { type: 'receiveName', name }});

	commit('setName', { name });
}

export const receiveName = ({ commit }, { message, peer_id }) => {
	commit('setName', { name: message.name, peer_id });
}

export const updatePosition = ({ commit, dispatch }, point) => {
	dispatch('sendMessage', { message: { type: 'receivePosition', ...point } } );

	commit('setPosition', {point});
}

export const receivePosition = ({ commit }, { message, peer_id }) => {
	commit('setPosition', {point: message, peer_id});
}



export const updateDirection = ({ commit, dispatch }, angle) => {
	dispatch('sendMessage', { message: { type: 'receiveDirection', angle }});
	commit('setDirection', {angle});
}

export const receiveDirection = ({ commit }, { message, peer_id }) => {
	commit('setDirection', {angle: message.angle, peer_id});
}


export const updateFaceDistance = ({ commit, dispatch }, distance) => {
	dispatch('sendMessage', { message: { type: 'receiveFaceDistance', distance }});
	commit('setFaceDistance', {distance});
}

export const receiveFaceDistance = ({ commit }, { message, peer_id }) => {
	commit('setFaceDistance', {distance: message.distance, peer_id});
}


export const updatePointer = ({ commit, dispatch }, pointer) => {
	dispatch('sendMessage', { message: { type: 'receivePointer', pointer }});
	commit('setPointer', { pointer });
}

export const receivePointer = ({ commit }, {message, peer_id }) => {
	commit('setPointer', { pointer: message.pointer, peer_id });
}


export const updateColor = ({ commit, dispatch }, color) => {
	dispatch('sendMessage', { message: { type: 'receiveColor', color }});
	commit('setColor', { color });
}

export const receiveColor = ({ commit }, { message, peer_id }) => {
	commit('setColor', { color: message.color, peer_id });
}

export const updateMuted = ({ commit, dispatch }, muted) => {
	dispatch('sendMessage', { message: { type: 'receiveMuted', muted }});
	commit('setMuted', { muted });
}

export const receiveMuted = ({ commit, dispatch }, { message, peer_id }) => {
	commit('setMuted', { muted: message.muted, peer_id });
}


export const updateOrder = ({ commit, dispatch }, order) => {
	dispatch('sendMessage', { message: { type: 'receiveOrder', order }});
	commit('setOrder', { order });
}
export const receiveOrder = ({ state, commit, getters, dispatch }, { message, peer_id }) => {
	commit('setOrder', { order: message.order, peer_id });

	for(peer_id in state.peers) {
		// if connection is closed, remove peer
		if(state.peers[peer_id].connection.connectionState == 'failed' || state.peers[peer_id].connection.iceConnectionState == 'disconnected') {
			commit('removePeer', peer_id)
		}
	}

	if(getters.getVIP == state.self) {
		//console.log('sendObjects', JSON.parse(JSON.stringify(state.objects)));
		dispatch('sendMessage', { message: { type: 'receiveObjects', objects: state.objects }, peer_id });
		dispatch('sendMessage', { message: { type: 'receiveRooms', rooms: state.rooms }, peer_id });

		dispatch('sendMessage', { message: { type: 'receivePlaylist', playlist: state.boombox.playlist.slice() }, peer_id });
		//dispatch('receivePlaylist', { message: { playlist: state.boombox.playlist }});
		dispatch('sendMessage', { message: { type: 'receivePlaying', value: state.boombox.playing }, peer_id });
		dispatch('sendMessage', { message: { type: 'receiveCurrent', current: state.boombox.current }, peer_id });
	}
}


/* BOOMBOX / PLAYLIST (OBSOLETE) */

export const togglePlay = ({ state, commit, dispatch }) => {
	let newState = !state.boombox.playing;

	dispatch('sendMessage', { message: { type: 'receivePlaying', value: newState }});
	commit('setPlaying', newState);
}

export const receivePlaying = ({ commit }, { message, peer_id }) => {
	commit('setPlaying', message.value);
}

export const addPlaylistItem = ({ commit, dispatch }, data) => {
	dispatch('sendMessage', { message: { type: 'receivePlaylistItem', data }});
	commit('addPlaylistItem', data);
}

export const receivePlaylistItem = ({ commit }, { message, peer_id }) => {
	commit('addPlaylistItem', message.data);
}

export const removePlaylistItem = ({ commit, dispatch }, video_id) => {

}

export const nextVideo = ({ state, commit, dispatch }) => {
	let currentVideo = getVideoFromPlaylist(state.boombox.current, state.boombox.playlist);
	
	let index = state.boombox.playlist.indexOf(currentVideo);
	let newVideoID = state.boombox.playlist[(index+1) % state.boombox.playlist.length].video_id;

	dispatch('sendMessage', { message: { type: 'receiveCurrent', current: newVideoID }});
	commit('setCurrent', newVideoID);
}

export const receiveCurrent = ({ commit }, { message, peer_id }) => {
	commit('setCurrent', message.current);
}

export const receivePlaylist = ({ commit, getters, state }, { message, peer_id }) => {
	if(getters.getVIP != state.self) {
		commit('setPlaylist', message.playlist);
	}	
}

/* CHAT */

/*export const updateEmote = ({ commit, dispatch }, emote) => {
	dispatch('sendMessage', { message: { type: 'receiveEmote', emote } } );
	commit('setEmote', {emote});
}

export const receiveEmote = ({ commit }, { message, peer_id }) => {
	commit('setEmote', {emote: message.emote, peer_id: peer_id});
}*/

export const sendChat = ({ commit, dispatch }, text) => {
	let chat = { text, timestamp: Date.now() };

	dispatch('sendMessage', { message: { type: 'receiveChat', chat } } );
	commit('appendChat', { chat });
}

export const receiveChat = ({ commit }, { message, peer_id }) => {
	commit('appendChat', { chat: message.chat, peer_id: peer_id });
}

/* OBJECTS */

export const receiveObjects = ({ commit, getters, state }, { message, peer_id }) => {
	if(getters.getVIP != state.self) {
		//console.log("RECEIVEOBJECTS", message, message.objects, message['objects'])
		commit('setObjects', message.objects);
	}
}

export const updateObjectProps = ({ commit, dispatch }, props) => {
	dispatch('sendMessage', { message: { type: 'receiveObjectProps', props }});
	commit('setObjectProps', props);
}

export const receiveObjectProps = ({ commit }, { message, peer_id }) => {
	commit('setObjectProps', message.props);
}

export const createObject = ({ commit, dispatch }, object) => {
	dispatch('sendMessage', { message: { type: 'receiveCreateObject', object }});
	commit('createObject', object);
}

export const receiveCreateObject = ({ commit }, { message, peer_id }) => {
	commit('createObject', message.object);
}

export const destroyObject = ({ commit, dispatch }, object_id) => {
	dispatch('sendMessage', { message: { type: 'receiveDestroyObject', object_id }});
	commit('destroyObject', object_id);
}

export const receiveDestroyObject = ({ commit }, { message, peer_id }) => {
	commit('destroyObject', message.object_id);
}

/* ROOM */

export const receiveRooms = ({ commit, getters, state }, { message, peer_id }) => {
	if(getters.getVIP != state.self) {
		commit('setRooms', message.rooms);
	}
}

export const updateRoomProps = ({ commit, dispatch }, props) => {
	dispatch('sendMessage', { message: { type: 'receiveRoomProps', props }});
	commit('setRoomProps', props);
}

export const receiveRoomProps = ({ commit }, { message, peer_id }) => {
	commit('setRoomProps', message.props);
}

export const createRoom = ({ commit, dispatch }, room) => {
	dispatch('sendMessage', { message: { type: 'receiveCreateRoom', room }});
	commit('createRoom', room);
}

export const receiveCreateRoom = ({ commit }, { message, peer_id }) => {
	commit('createRoom', message.room);
}

export const destroyRoom = ({ commit, dispatch }, room_id) => {
	dispatch('sendMessage', { message: { type: 'receiveDestroyRoom', room_id }});
	commit('destroyRoom', room_id);
}

export const receiveDestroyRoom = ({ commit }, { message, peer_id }) => {
	commit('destroyRoom', message.room_id);
}


/* OTHER */

export const createContextMenu = ({ commit }, data) => {
	commit('setContextMenu', data);
}


export const updateObjectMode = ({ commit }, objectMode) => {
	commit('setObjectMode', objectMode);
}


export const toggleBroadcast = ({ commit, dispatch, state }) => {
	let value = !state.self.broadcasting;
	console.log("toggle broadcasting! New value:", value)
	dispatch('sendMessage', { message: { type: 'receiveBroadcast', value } });
	commit('setBroadcast', { value })
}

export const receiveBroadcast = ({ commit }, { message, peer_id }) => {
	commit('setBroadcast', { value: message.value, peer_id });
}
